// Best-effort reCAPTCHA v3. The backend verifies the token on confirm/capture.
// Site key registered for garagesanmarco.it; on localhost verification may fail,
// which the UI surfaces as a normal error. Set VITE_RECAPTCHA_SITE_KEY to enable.
const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined

let loaded: Promise<void> | null = null

function loadScript(): Promise<void> {
  if (!SITE_KEY) return Promise.resolve()
  if (loaded) return loaded
  loaded = new Promise((resolve) => {
    if ((window as any).grecaptcha) return resolve()
    const s = document.createElement('script')
    s.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`
    s.async = true
    s.onload = () => resolve()
    s.onerror = () => resolve()
    document.head.appendChild(s)
  })
  return loaded
}

export async function getCaptchaToken(action = 'confirm'): Promise<string> {
  if (!SITE_KEY) return ''
  await loadScript()
  const grecaptcha = (window as any).grecaptcha
  if (!grecaptcha?.execute) return ''
  try {
    return await new Promise<string>((resolve) => {
      grecaptcha.ready(() => grecaptcha.execute(SITE_KEY, { action }).then(resolve).catch(() => resolve('')))
    })
  } catch {
    return ''
  }
}
